<div class="router-bar">
  <div class="route-button" [ngClass]="{'current-route': router.url === '/projects'}">
    <button mat-button [routerLink]="['/projects']">Projects</button>
  </div>
  <div class="route-button" [ngClass]="{'current-route': router.url === '/customers'}">
    <button mat-button [routerLink]="['/customers']">Customers</button>
  </div>
  <div class="route-button" [ngClass]="{'current-route': router.url === '/client-nfs'}">
    <button mat-button [routerLink]="['/client-nfs']">Client Nfs</button>
  </div>
</div>

<p-table #dt [value]="this.projects$ | async" [paginator]="true" [lazy]="true" (onLazyLoad)="loadProjectsLazy($event)"
         [lazyLoadOnInit]="false" [rows]="projectsPerPage" [totalRecords]="totalElements$ | async"
         selectionMode="single"
         (onRowSelect)="openProject($event)" [loading]="loadingProjects">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of cols" (click)="sortByHeader(col.field)" matRipple>
        {{col.header}}

        <i *ngIf="sortMap.get(col.field) === 1" class="pi pi-arrow-down"></i>
        <i *ngIf="sortMap.get(col.field) === 2" class="pi pi-arrow-up"></i>

      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="cols">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of cols">
        <ng-container>
          {{getFieldData(rowData, col)}}
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary">
    <div class="customers-counter">
      {{footerString}}
    </div>
  </ng-template>
</p-table>
